import { z } from 'zod'
import { utcTimestampSchema } from './common'

/**
 * PROVISIONAL realtime envelope until the backend defines its WebSocket protocol.
 * Server → client: `{ topic, ts, payload }`. Client → server: `{ action, topic }`.
 */
export const realtimeMessageSchema = z.object({
  topic: z.string().min(1),
  ts: utcTimestampSchema,
  payload: z.unknown(),
})
export type RealtimeEnvelope = z.infer<typeof realtimeMessageSchema>

export const realtimeCommandSchema = z.object({
  action: z.enum(['subscribe', 'unsubscribe']),
  topic: z.string().min(1),
})
export type RealtimeCommand = z.infer<typeof realtimeCommandSchema>
